import { z } from "zod"
import ValidateOrFail from "./ValidateOrFail.js"

/**
 * @description
 *	Validates that a given input model matchs the provided schema. If the
 *	validation fails, returns undefined.
 */
const Validate = <S extends z.ZodTypeAny>(schema: S, input: unknown): z.infer<S> | undefined => {
	try {
		return ValidateOrFail(schema, input)
	} catch {
		return undefined
	}
}

export default Validate
